import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-[12px] font-medium text-slate-600 mb-1">{label}</label>
        )}
        <input
          ref={ref}
          className={`w-full px-3 py-1.5 rounded-md bg-white border text-[13px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#00A871]/30 focus:border-[#00A871]/50 transition-colors ${
            error ? 'border-red-500' : 'border-slate-200'
          } ${className}`}
          {...props}
        />
        {error && <p className="mt-1 text-[11px] text-red-600">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
